import React from 'react';
import IntegrationForm from '@components/service-integrations/integration-form';

function FormView() {
  return <IntegrationForm />;
}

export default FormView;
